exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-6f1ceeca],span.beleive[_v-6f1ceeca]{color:#942a77!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6f1ceeca&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/pages/content-owners.vue
 ** module id = 24
 ** module chunks = 0
 **/